function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.185 7.262c0 3.267-2.649 5.924-5.906 5.924-3.256 0-5.907-2.65-5.907-5.906 0-3.267 2.65-5.925 5.907-5.925 3.258 0 5.906 2.65 5.906 5.907M7.28.25C3.404.25.25 3.404.25 7.28c0 3.876 3.155 7.028 7.03 7.028 3.877 0 7.028-3.152 7.028-7.028 0-3.876-3.152-7.03-7.028-7.03"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M13.185 7.262c0 3.267-2.649 5.924-5.906 5.924-3.256 0-5.907-2.65-5.907-5.906 0-3.267 2.65-5.925 5.907-5.925 3.258 0 5.906 2.65 5.906 5.907zM7.28.25C3.404.25.25 3.404.25 7.28c0 3.876 3.155 7.028 7.03 7.028 3.877 0 7.028-3.152 7.028-7.028 0-3.876-3.152-7.03-7.028-7.03z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.358 5.361c0-.902.881-1.63 1.974-1.63 1.092 0 1.973.728 1.973 1.63v1.514c0 .902-.88 1.63-1.973 1.63s-1.974-.728-1.974-1.63V5.361zM7.314 9.35c1.656 0 2.996-1.106 2.996-2.474V5.361c0-1.367-1.34-2.474-2.996-2.474-1.657 0-2.996 1.107-2.996 2.474v1.514C4.336 8.243 5.674 9.35 7.314 9.35z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M5.358 5.361c0-.902.881-1.63 1.974-1.63 1.092 0 1.973.728 1.973 1.63v1.514c0 .902-.88 1.63-1.973 1.63s-1.974-.728-1.974-1.63V5.361zM7.314 9.35c1.656 0 2.996-1.106 2.996-2.474V5.361c0-1.367-1.34-2.474-2.996-2.474-1.657 0-2.996 1.107-2.996 2.474v1.514C4.336 8.243 5.674 9.35 7.314 9.35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.025 10.326c-.457.406-1.08.64-1.71.64-.65 0-1.249-.228-1.732-.66-.202-.163-.475-.184-.658-.056l-1.48.916-.056.035.048.044c.284.266.571.492.854.676l.026.017.862-.529c.623.438 1.38.678 2.135.678.771 0 1.501-.228 2.116-.66l.801.495.027.016.027-.017c.302-.198.59-.43.853-.695l.045-.045-1.498-.913c-.204-.129-.474-.108-.66.058"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M9.025 10.326c-.457.406-1.08.64-1.71.64-.65 0-1.249-.228-1.732-.66-.202-.163-.475-.184-.658-.056l-1.48.916-.056.035.048.044c.284.266.571.492.854.676l.026.017.862-.529c.623.438 1.38.678 2.135.678.771 0 1.501-.228 2.116-.66l.801.495.027.016.027-.017c.302-.198.59-.43.853-.695l.045-.045-1.498-.913c-.204-.129-.474-.108-.66.058z"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.559d3ba6.svg";
export { ForwardRef as ReactComponent };